import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { trackWhatsAppClick } from '../hooks/useMetaPixel';
const WA_BASE = 'https://wa.me/50685316690';
const plans = [{
  name: 'Plan Básico',
  price: '50,000',
  frequency: '1 publicación por semana (4 al mes)',
  desc: 'Ideal para comenzar a construir presencia digital con base estratégica.',
  highlighted: false,
  whatsappMessage: 'Hola, estoy interesado(a) en el *Plan Básico* de Redes Sociales (₡50,000/mes) para mi negocio. Me gustaría más información.'
}, {
  name: 'Plan Recomendado',
  price: '80,000',
  frequency: '3 publicaciones por semana (12 al mes)',
  desc: 'Balance ideal entre inversión y crecimiento. Mayor frecuencia = más oportunidades de venta.',
  highlighted: true,
  badge: 'POPULAR',
  whatsappMessage: 'Hola, estoy interesado(a) en el *Plan Recomendado* de Redes Sociales (₡80,000/mes) para mi negocio. Me gustaría más información.'
}, {
  name: 'Plan Intensivo',
  price: '120,000',
  frequency: '5 publicaciones por semana (20 al mes)',
  desc: 'Máxima presencia digital. Más contenido estratégico = más clientes potenciales.',
  highlighted: false,
  whatsappMessage: 'Hola, estoy interesado(a) en el *Plan Intensivo* de Redes Sociales (₡120,000/mes) para mi negocio. Me gustaría más información.'
}];
const includedFeatures = ['Grabación de contenido', 'Planeación estratégica', 'Branding visual', 'Guiones y copywriting', 'Edición profesional', 'Análisis de métricas', 'Estudio de competencia', 'Adaptación a tendencias', 'Estrategia funnel'];
export function SocialMediaPricingSection() {
  return <section className="py-24 bg-[#050510] relative overflow-hidden" data-id="element-396">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-397">
        <div className="text-center mb-16" data-id="element-398">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold font-orbitron mb-6 text-purple-400" data-id="element-399">
            Planes de Crecimiento Mensual
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 max-w-3xl mx-auto text-lg" data-id="element-400">
            Elige el plan que mejor se adapte a tu ritmo de crecimiento. Todos
            incluyen producción, estrategia, edición, copywriting y análisis de
            métricas.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-16 items-stretch" data-id="element-401">
          {plans.map((plan, index) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className={`relative flex flex-col rounded-2xl p-8 border transition-all duration-300 ${plan.highlighted ? 'bg-[#0a0a1a] border-yellow-500/50 shadow-[0_0_30px_rgba(234,179,8,0.15)] lg:-mt-4 lg:mb-[-16px]' : 'bg-[#0a0a1a]/80 border-white/10 hover:border-purple-500/30'}`} data-id="element-402">
              {plan.badge && <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-403">
                  <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-black text-xs font-bold px-4 py-1.5 rounded-full flex items-center gap-1 shadow-lg" data-id="element-404">
                    <Star className="w-3 h-3 fill-black" data-id="element-405" />
                    {plan.badge}
                  </div>
                </div>}

              <div className="text-center mb-6 pt-4" data-id="element-406">
                <div className="text-gray-500 font-orbitron text-xl mb-4" data-id="element-407">
                  {index + 1}
                </div>
                <h3 className="text-xl font-bold text-white mb-4 flex items-center justify-center gap-2" data-id="element-408">
                  <div className={`w-3 h-3 rotate-45 ${plan.highlighted ? 'bg-yellow-400' : 'bg-blue-500'}`} data-id="element-409" />
                  {plan.name}
                </h3>
                <div className="flex items-baseline justify-center gap-1 mb-4" data-id="element-410">
                  <span className="text-2xl text-gray-400 font-bold" data-id="element-411">₡</span>
                  <span className="text-4xl font-bold text-white font-orbitron" data-id="element-412">
                    {plan.price}
                  </span>
                  <span className="text-gray-500" data-id="element-413">/ mes</span>
                </div>
                <p className="text-sm text-gray-300 font-medium mb-4" data-id="element-414">
                  {plan.frequency}
                </p>
                <p className="text-sm text-gray-500" data-id="element-415">{plan.desc}</p>
              </div>

              <div className="mt-auto pt-8" data-id="element-416">
                <a href={`${WA_BASE}?text=${encodeURIComponent(plan.whatsappMessage)}`} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick()} className={`block w-full py-3 rounded-xl font-bold text-center transition-all duration-300 ${plan.highlighted ? 'bg-yellow-500 text-black hover:bg-yellow-400 hover:shadow-[0_0_20px_rgba(234,179,8,0.4)]' : 'bg-white/10 text-white hover:bg-white/20'}`} data-id="element-417">
                  Elegir Plan
                </a>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-418">
          <h4 className="text-xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-419">
            <div className="w-6 h-6 rounded bg-green-500 flex items-center justify-center" data-id="element-420">
              <Check className="w-4 h-4 text-white" data-id="element-421" />
            </div>
            Todos los planes incluyen:
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-422">
            {includedFeatures.map((feature, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-lg p-4 text-sm text-gray-300 font-medium hover:bg-white/10 transition-colors" data-id="element-423">
                {feature}
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="border-l-2 border-cyan-500 pl-6 py-2" data-id="element-424">
          <p className="text-gray-400 italic text-lg" data-id="element-425">
            "Mientras más contenido estratégico tenga tu negocio, más
            oportunidades hay de que le compren."
          </p>
        </motion.div>
      </div>
    </section>;
}